import { useParams } from "react-router-dom";
import { getCurrency } from "translations/currency";

export function useCurrencyCode() {
    const { system } = useParams();
    const currency = getCurrency(system);
    return currency;
}
